import {FC, useEffect, useState} from 'react'

type TestProgressBarProps = {
    current: number // текущий шаг (с 0)
    total: number   // всего шагов
}

const TestProgressBar: FC<TestProgressBarProps> = ({ current, total }) => {
    const percent = Math.round(((current + 1) / total) * 100)

    const [progressWidth, setProgressWidth] = useState("0%")

    useEffect(() => {
        if (current > 0) {
            setProgressWidth(`${percent}%`)
            return
        }

        setProgressWidth("0%")
        const timer = setTimeout(() => {
            setProgressWidth(`${percent}%`)
        }, 50)

        return () => clearTimeout(timer)
    }, [current, percent])

    return (
        <div className="moduleTakeTest_progress_bar_wrapper testProgressBar--animated">
            <div className="moduleTakeTest_progress_bar progress">
                <div
                    className="progress-bar"
                    role="progressbar"
                    style={{ width: progressWidth }}
                    aria-valuenow={current + 1}
                    aria-valuemin={0}
                    aria-valuemax={total}
                />
            </div>
        </div>
    )
}

export default TestProgressBar
